import { LockerListTable } from '@/components/entities/locker/LockerListTable'
import { ButtonLink } from '@/components/lib/ButtonLink'
import { useUserRole } from '@/hooks/useUserRole'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useOutletContext } from 'react-router-dom'

type ContextType = {
  setTitle: React.Dispatch<React.SetStateAction<string>>
}

export const LockerList = () => {
   const { setTitle } = useOutletContext<ContextType>()
    const myRole = useUserRole();
  
    React.useEffect(() => {
      setTitle('Lockers')
    }, [setTitle])
  

  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row>
        <Col>
          {myRole === import.meta.env.VITE_APP_ROLE_SUPER_ADMIN && (
            <ButtonLink name={'Nouvelle machine'} href={'/lockers/creation'} icon={'Plus'} />
          )}
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col>
          <LockerListTable />
        </Col>
      </Row>
    </>
  )
}
